export const CIQ_EVENTS_FILTERS_SECTION = 'ciq-events-filters';
